import { toast } from '@/utils/toast';
import { useEffect } from 'react';
import { signOutHandler } from '@/utils/auth';
import { useSession } from 'next-auth/react';
import useGlobalStore from '@/store/global.store';

export function useSessionTimeout() {
  const { data: session } = useSession();
    const { setIsOldUser } = useGlobalStore();
  useEffect(() => {
    if (session && session?.customExpires) {
      const expiryTime = new Date(session.customExpires).getTime();
      const now = Date.now();

      const timeUntilExpiry = expiryTime - now;
      if (timeUntilExpiry > 0) {
        const timer = setTimeout(() => {
          signOutHandler(setIsOldUser, session?.user);
          toast.error('Session Expired');
        }, timeUntilExpiry);

        return () => clearTimeout(timer);
      } else {
        signOutHandler(setIsOldUser, session?.user);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);
}
